import React, { useCallback, useEffect } from "react";
import * as notify from "../../../../shared/notify";

import "./nutrition.scss";
import { useModal } from "../../../../shared/hooks/use-modal";
import { ColumnShifterModal } from "./components/column-shifter-modal";
import { NutritionProvider } from "./providers/nutrition-provider";
import { Panels } from "./components/panels";

const NutritionIndex = (props) => {
    const { open, onOpen, onClose } = useModal();

    useEffect(() => {
        document.body.classList.add("-modal-showing");
    }, [open]);

    const handleClosePanel = async (isDirty) => {
        if (isDirty) {
            const confirm = await notify.confirm("You have unsaved data.  Are you sure you want to navigate away? Unsaved data will be lost!");

            if (!confirm) {
                return;
            }
        }

        props.closeModal();
    };

    const handleOpenMovePanelModal = useCallback(() => {
        onOpen();

        if (props.onUpdateModalStyles) {
            props.onUpdateModalStyles("invisible");
        }
    }, [onOpen, props.onUpdateModalStyles]);

    const handleCloseColumnShifter = useCallback(() => {
        onClose();

        if (props.onUpdateModalStyles) {
            props.onUpdateModalStyles("");
        }
    }, [onClose, props.onUpdateModalStyles]);

    return (
        <NutritionProvider panelInfo={props}>
            {open && (
                <ColumnShifterModal
                    open={open}
                    onClose={handleCloseColumnShifter}
                />
            )}
            <Panels
                readOnly={false}
                onClosePanel={handleClosePanel}
                onOpenPanelModal={handleOpenMovePanelModal}
                isNutritionPanel={props.attribute.key === "nutritionPanel"}
                isQaEdit={props.isQaEdit}
                togglePanel={props.togglePanel}
            />
        </NutritionProvider>
    );
};

export default NutritionIndex;
